module.exports = __webpack_public_path__ + "img/invite-qr-logo.d3a7ade0.png";